

import { toast } from "react-toastify";
import { handleApiCallErrors } from "../../../utils/error_handler";
import { ParseURI } from "../../../utils/parse_uri"
import { getRequester } from "../../configs";
import { FinalizeTypes } from "./finalize.reducer";





export const finalizePayment = (payment_id: string, card: string, month: string, year: string, cvv2: string, pin: string, cb: Function) => (dispatch: any) => {
    var { merchent, transaction } = ParseURI();
    dispatch({
        type: FinalizeTypes.FINALIZE_PAYMENT,
        data: null,
        is_loading: true
    })

    var _toastPromise = getRequester().post("/v1/payments/finalizePayment", {
        "merchent_id": merchent,
        "transaction_uuid": transaction,
        "unique_id": payment_id,
        "source_card": card,
        "pin": pin,
        "exp_month": month,
        "exp_year": year,
        "cvv2": cvv2
    }, {
        headers: {
            // @ts-ignore
            "IDS": sessionStorage.getItem("IDS")
        }
    }).then(body => {
        cb();
        sessionStorage.clear();
        return dispatch({
            type: FinalizeTypes.FINALIZE_PAYMENT,
            // @ts-expect-error
            data: body.data.data,
            is_loading: false
        })
    })


    toast.promise(_toastPromise, {
        pending: "درحال پرداخت...",
        success: "پرداخت انجام شد...",
        error: "",
    }).catch(err => {
        handleApiCallErrors(err);

        dispatch({
            type: FinalizeTypes.FINALIZE_PAYMENT,
            data: null,
            is_loading: false
        })
    })
}



